export default __webpack_public_path__ + "static/transaction-page-requested-b332c6b46cad71d01200dcdfe830733b.png";